import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { client } from "@/hono";

export function useOrderTemplates() {
	const query = useQuery({
		queryKey: ["order-templates"],
		queryFn: async () => {
			const response = await client.stock["order-templates"].$get();
			const data = await responseHandler(response);
			return data.orderTemplates;
		},
	});

	return {
		...query,
		orderTemplates: query.data,
	};
}
